// extracted by mini-css-extract-plugin
export default {"drawerContent":"InfoDrawer_drawerContent__slE3B","drawerDivider":"InfoDrawer_drawerDivider__+4fXt","drawerContainer":"InfoDrawer_drawerContainer__QbPyq"};